@if (callRunning) {
    <div class="fancy-loader"></div>
} @else {
    @if (releasedConfig) {
        <generic-list-manager [config]="releasedConfig"></generic-list-manager>
    }
    @if (unreleasedConfig) {
        <generic-list-manager [config]="unreleasedConfig"></generic-list-manager>
    }
}
